import React, { Component } from 'react';
import { noop, isEqual } from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { FormFieldError } from 'shared/components';
import { isErrorCode } from './checkError';

import theme from './FormStyles.scss';

const propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.any,
    name: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pristine: PropTypes.bool,
    submitFailed: PropTypes.bool,
  }).isRequired,
  className: PropTypes.string,
  errorMessagesMap: PropTypes.object,
  inputValue: PropTypes.any,
  onBlur: PropTypes.func,
  tooltipType: PropTypes.oneOf(['text', 'hint', 'intl']),
  tooltipTestId: PropTypes.string,
  tooltipSize: PropTypes.oneOf(['medium', 'large']),
  tooltipWidth: PropTypes.number,
  tooltipPlacement: PropTypes.string,
};

const defaultProps = {
  className: null,
  errorMessagesMap: {},
  inputValue: null,
  onBlur: noop,
  tooltipType: undefined,
  tooltipTestId: 'tooltip',
  tooltipSize: 'large',
  tooltipWidth: null,
  tooltipPlacement: 'bottomStart',
};

class InputProxy extends Component {

  shouldComponentUpdate(nextProps) {
    return nextProps.inputValue !== this.props.input.value || !isEqual(nextProps.meta, this.props.meta);
  }

  componentDidUpdate(prevProps) {
    const { inputValue, input: { onChange, onBlur } } = this.props;

    if (!isEqual(inputValue, prevProps.input.value)) {
      onChange(inputValue);
      onBlur();
    }
  }

  render() {
    const {
      input,
      meta: { error, submitFailed, invalid, touched },
      className,
      errorMessagesMap,
      tooltipType,
      tooltipTestId,
      tooltipSize,
      tooltipWidth,
      tooltipPlacement,
    } = this.props;

    const errorMessage = !isErrorCode(error)
      ? { defaultMessage: error, id: 'default' }
      : error && errorMessagesMap[error];

    return (
      <div className={ classnames(theme.hidden, className) } >
        <input { ...input } type="hidden" />
        <If condition={ error && invalid && submitFailed && touched }>
          <FormFieldError
            tooltipType={ tooltipType }
            testId={ tooltipTestId }
            width={ tooltipWidth }
            tooltipMessage={ errorMessage }
            tooltipSize={ tooltipSize }
            tooltipPlacement={ tooltipPlacement }
          />
        </If>
      </div>
    );
  }
}

InputProxy.propTypes = propTypes;
InputProxy.defaultProps = defaultProps;

export default InputProxy;
